import { useContext } from 'react'

import { JourneyContext, JourneyContextProps } from '@/contexts/journey'

interface UseJourneyProps {
  initialized: JourneyContextProps['initialized']
}

export const useJourney = (): UseJourneyProps => {
  const { initialized } = useContext(JourneyContext)

  return {
    initialized
  }
}
